module.exports = __webpack_public_path__ + "static/media/emoji-happy.7aee2ae0.svg";